import { Injectable } from '@angular/core';

import { InfoboxService } from './infobox/infobox.service';
import { Data2Service } from './data2.service';
import { UuidService } from './uuid.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
	providedIn: 'root',
})
export class TaskService {
	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly auth: AuthService,
	) {}

	add(
		objType: string,
		objId: string | number,
		owners: Array<string | number>,
		deadline: string,
		content: string,
		callback: () => void,
	) {
		const task = {
			id: new UuidService().generate(),
			objType: objType,
			objId: objId,
			type: 'TASK',
			status: 1,
			author: this.auth.getUserId(),
			owners: owners,
			deadline: deadline,
			content: content,
		};
		this.api.post('/tasks/', task, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Dodano zadanie');
			callback();
		});
	}
}
